import { SITE_CONFIG } from '../../config/site-config';
import { isConfigured, mailto, routeHref, salesMailto } from '../../lib/links';
import { logo } from '../logo';
import { inceptionBadgeLink } from '../nvidia-inception';
import { configuredNetworks, socialLink } from '../social';

export function footer(): string {
  const col = (h: string, links: readonly (readonly [label: string, url: string, attrs?: string])[]): string =>
    `<div><h2 class="fh">${h}</h2><ul>${links.map(([t, u, x]) => `<li><a href="${u}" ${x ?? ''}>${t}</a></li>`).join('')}</ul></div>`;
  const soc = configuredNetworks();
  const a = SITE_CONFIG.ADDRESS;
  return `
  <footer>
    <div class="wrap">
      <div class="fgrid ${soc.length ? 'with-follow' : ''}">
        <div class="fbrand">
          <a class="logo" href="${routeHref('/')}" aria-label="ReTax360 home">${logo('dark')}</a>
          <p class="tagline">AI + Expertise. Built around how you work.</p>
          ${inceptionBadgeLink('finception')}
        </div>
        ${col('Product', [
          ['Platform', routeHref('/platform')],
          ['AI Orchestration', routeHref('/platform#orchestration')],
          ['Intelligent Intake', routeHref('/platform#intake')],
          ['Document Intelligence', routeHref('/platform#document-intelligence')],
          ['Settlement Intelligence', routeHref('/platform#settlement')],
          ['Integrations', routeHref('/platform#integrations')],
          ['Security &amp; Trust', routeHref('/security')],
        ])}
        ${col('Solutions', [
          ['Advisory &amp; Valuation Firms', routeHref('/solutions#advisory')],
          ['Property Tax Practices', routeHref('/solutions#practices')],
          ['Enterprise CRE Portfolios', routeHref('/solutions#cre-portfolios')],
        ])}
        ${col('Resources', [
          ['Insights', routeHref('/insights')],
          ['AI &amp; Orchestration', routeHref('/insights?category=ai-orchestration')],
          ['Product Updates', routeHref('/insights?category=product-updates')],
          ['Capacity Calculator', routeHref('/calculator')],
          ['Customers', routeHref('/customers')],
          ['Security', routeHref('/security')],
        ])}
        ${col('Company', [
          ['Our Thesis', routeHref('/company')],
          ['Careers', routeHref('/careers')],
          ['Contact', routeHref('/contact')],
          ['Privacy Policy', routeHref('/privacy')],
          ['Terms of Service', routeHref('/terms')],
        ])}
        ${soc.length ? `<div><h2 class="fh">Follow</h2><ul class="fsoc">${soc.map((k) => `<li>${socialLink(k)}</li>`).join('')}</ul></div>` : ''}
      </div>
      <div class="fmeta">
        <address>${SITE_CONFIG.LEGAL_NAME}<br>${a.street}<br>${a.city}, ${a.region} ${a.postalCode}<br>${a.country}</address>
        <p>Enterprise Sales: <a href="${salesMailto()}">${SITE_CONFIG.SALES_EMAIL}</a><br>General &amp; Careers: <a href="${mailto(SITE_CONFIG.INFO_EMAIL)}">${SITE_CONFIG.INFO_EMAIL}</a></p>
      </div>
      <div class="fbot">
        <span>© ${SITE_CONFIG.COPYRIGHT_YEAR} ${SITE_CONFIG.LEGAL_NAME}</span>
        <nav aria-label="Legal"><a href="${routeHref('/privacy')}">Privacy Policy</a><a href="${routeHref('/terms')}">Terms of Service</a><a href="${routeHref('/security')}">Security</a>${isConfigured(SITE_CONFIG.GA4_ID) ? '<a href="#" data-cookie-settings>Cookie settings</a>' : ''}<a href="${routeHref('/quebec')}" hreflang="fr-CA" lang="fr-CA">Français (Québec)</a></nav>
      </div>
    </div>
  </footer>
  <div class="themer" id="themer" role="group" aria-label="Theme preview (dev only)">
    <span>theme</span>
    <button data-theme="aurora">Aurora</button><button data-theme="deep">Deep</button><button data-theme="mint">Mint</button>
  </div>`;
}
